import { produce } from 'immer';
import React, { useCallback } from 'react';

import type { SearchFilters } from '../../../../../js/@types/SearchFilters';
import SpeedDataSelect from '../../home/SpeedDataSelect';
// import SliderWithLabel from '../../../../../../Shared/React/js/components/sliders/SliderWithLabel';

type SpeedRangeProps = SearchFilters['speedSlider'];

interface Props extends SpeedRangeProps {
    current: number;
    maxSpeed?: number;
    onChanged: (value: { min: number; max: number }) => void;
    dataWidth?: string;
}

const SpeedFilter = (props: Props) => {
    const getTooltipProps = useCallback(() => {
        return produce(props.tooltipHtmlAttributes, (draft: { 'data-content': string }) => {
            const template = document.createElement('div');
            template.innerHTML = draft['data-content'];

            const [speedFragment] = Array.prototype.slice
                .call(template.children)
                .filter((p: HTMLElement) => p.innerText.includes(props.speedDescriptionPlaceholder));

            if (speedFragment) {
                template.removeChild(speedFragment);
            }

            // Remove whitespaces
            template.innerHTML = template.innerHTML.trim();

            // Remove first HR
            const hr = template.querySelector('hr');
            if (hr && hr.previousSibling === null) {
                template.removeChild(hr);
            }

            draft['data-content'] = template.innerHTML;
        });
    }, [props.speedDescriptionPlaceholder, props.tooltipHtmlAttributes]);

    const tooltipProps = getTooltipProps();
    const handleSpeedChange = useCallback(
        (value: { min: number; max: number }) => {
            if (typeof value === 'object' && value !== null && 'min' in value && 'max' in value) {
                props.onChanged({ min: value.min, max: value.max });
            }
        },
        [props]
    );

    return (
        <>
            <div className="mar-y-4 font-4 c-gray-light line-height-11 hover-bg" {...tooltipProps}>
                <span>{props.speedLabel} </span>
                <span>
                    <i className="fa fa-info-circle"></i>
                </span>
            </div>
            <div className="selectpicker-wide">
                <SpeedDataSelect
                    primaryFilterAsSpeed={true}
                    speedRanges={props.speedRanges || []}
                    speed={props.current}
                    maxSpeed={props.maxSpeed}
                    onSpeedChange={handleSpeedChange}
                    speedFormat={'Mbps'}
                    className="dropdown bootstrap-select show-tick bs3"
                    dataWidth={props.dataWidth}
                />
            </div>
        </>
    );
};

export default SpeedFilter;
